var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C0 6.71625 6.71625 0 15 0C23.2837 0 30 6.71625 30 15C30 23.2837 23.2837 30 15 30C6.71625 30 0 23.2837 0 15ZM23.2606 11.2499L20.6244 8.61367L13.1244 16.1137L9.37438 12.3637L6.73813 14.9999L13.1244 21.3862L23.2606 11.2499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledChecked);
export default __webpack_public_path__ + "static/media/filled-checked.e426594b.svg";
export { ForwardRef as ReactComponent };